import useSWR from 'swr';
import { useAuth } from '@/contexts/AuthContext';
import { apiClient, AffiliateInfo } from '@/lib/api-client';
import { useCallback } from 'react';

export function useAffiliate() {
  const { user } = useAuth();

  const { data, error, isLoading, mutate } = useSWR<AffiliateInfo>(
    user?.uid ? ['affiliate', user.uid] : null,
    async () => {
      if (!user?.uid) throw new Error('User not authenticated');
      return apiClient.getAffiliateInfo();
    },
    {
      revalidateOnFocus: false,
      dedupingInterval: 5 * 60 * 1000,
      errorRetryCount: 2,
    }
  );

  const enroll = useCallback(async () => {
    const result = await apiClient.enrollAffiliate();
    mutate(result, { revalidate: false });
    return result;
  }, [mutate]);

  const refresh = useCallback(() => {
    mutate();
  }, [mutate]);

  return {
    data,
    error,
    isLoading,
    enrolled: data?.enrolled ?? false,
    referralCode: data?.referral_code ?? null,
    referralLink: data?.referral_link ?? null,
    totalEarned: data?.total_earned ?? 0,
    totalReferrals: data?.total_referrals ?? 0,
    enroll,
    refresh,
  };
}
